import React, { useMemo } from "react";
import "./LandingImersao.css";

// Ajuste os imports conforme seus paths reais:
import videoCelia from "./assets/video-celia.mp4";
import videoSandra from "./assets/video-sandra.mp4";
import fotoCelia from "./assets/celia.webp";
import fotoSandra from "./assets/sandra.webp";
import capaSandra from "./assets/capaSandra.webp";
import capaCelia from "./assets/capaCelia.webp";
import fotoSection from "./assets/foto-section.webp";
import fotoExperts from "./assets/foto-experts.webp";
import fotoImersao from "./assets/fotoImersao.webp";

export default function LandingImersao() {
  const EVENT_DATE = "11/04 às 10h";
  const EVENT_DURATION = "3 horas ao vivo";
  const CTA_TEXT = "EVENTO GRATUITO";

  const identificacaoPontos = useMemo(
    () => [
      <>
        Você percebe que, por mais esforço que faça, a{" "}
        <span className="lpHighlight">dívida nunca diminui</span>, só aumenta.
      </>,
      <>
        Você se{" "}
        <span className="lpHighlight">
          sente constrangido por estar devendo
        </span>
        , mas não sabe por onde começar a resolver.
      </>,
      <>
        Os contratos são confusos e{" "}
        <span className="lpHighlight">você não consegue entender</span> se o
        valor cobrado é realmente correto.
      </>,
      <>
        Você
        <span className="lpHighlight">
          {" "}
          já tentou conversar diretamente com o banco
        </span>
        , mas recebeu apenas respostas negativas.
      </>,
      <>
        Você não quer deixar de pagar, apenas{" "}
        <span className="lpHighlight">quer quitar o que é justo</span>.
      </>,
      <>
        <span className="lpHighlight">Está cansado</span> de ouvir que a única
        saída é fazer renda extra ou cortar tudo da sua vida.
      </>,
      <>
        Você sente que os{" "}
        <span className="lpHighlight">valores cobrados não são justos</span>.
      </>,
    ],
    []
  );

  const bancoTem = useMemo(
    () => ["estratégia", "metas", "treinamento", "informação"],
    []
  );

  const voceTem = useMemo(
    () => ["urgência", "medo de errar", "pouco tempo", "pouca transparência"],
    []
  );

  const beneficios = useMemo(
    () => [
      "Entender onde o seu dinheiro está escapando sem perceber",
      "Identificar quais dívidas são realmente perigosas",
      "Saber quando negociar e quando NÃO negociar",
      "Aprender a proteger seu salário de descontos indevidos",
      "Enxergar sua situação financeira com clareza estratégica",
      "Sair com um plano de ação realista, possível de executar",
    ],
    []
  );

  const conteudoProgramatico = useMemo(
    () => [
      "Por que o servidor público se endivida mesmo com renda fixa",
      "As falsas soluções que parecem ajuda, mas pioram o cenário",
      "Onde o banco ganha quando você não entende o contrato",
      "Seguro prestamista: quando é direito, quando é abuso",
      "Tipos de dívidas e o risco real de cada uma",
      "Como funciona a proteção do salário na prática",
      "Raio X financeiro: enxergando o problema certo primeiro",
      "Lei do Superendividamento aplicada à vida real",
      "Quando negociar, quando parar e quando buscar outro caminho",
      "Como não voltar para o ciclo da dívida",
    ],
    []
  );

  const paraQuemE = useMemo(
    () => [
      "É servidor público, aposentado ou pensionista",
      "Tem dívidas ativas ou salário comprometido",
      "Já tentou resolver sozinha e não funcionou",
      "Quer clareza antes de tomar novas decisões",
    ],
    []
  );

  const paraQuemNaoE = useMemo(
    () => [
      "Quer promessa milagrosa",
      "Quer “jeitinho” ilegal",
      "Não está disposta a olhar para a própria realidade",
    ],
    []
  );

  return (
    <div className="lp">
      {/* Topbar (minimal, estilo referência) */}
      <header className="lpTopbar">
        <h2 className="lpTopbarTitle">
          SERVIDOR, SAIBA O QUE FAZER COM AS SUAS DÍVIDAS
        </h2>
      </header>

      {/* PRIMEIRA DOBRA */}
      <section className="lpHero">
        <div className="lpHeroContent">
          <div className="lpContainer lpHeroStack">
            <div className="lpHeroCenter">
              <h1 className="lpH1 lpCenterText">
                Descubra um método comprovado para recuperar valores pagos e
                reduzir suas dívidas de consignado, sem precisar recorrer ao
                Judiciário!
              </h1>

              <p className="lpLead lpCenterText">
                Em 3 horas, você vai parar de se sentir perdido e entender
                exatamente o que fazer com suas dívidas.
              </p>

              <div className="lpMetaRow lpMetaRowCenter">
                <div className="lpMetaCard lpMetaCardHero">
                  <span className="lpMetaIcon">📅</span>
                  <div>
                    <p className="lpMetaTitleHero">{EVENT_DATE}</p>
                  </div>
                </div>

                <div className="lpMetaCard">
                  <span className="lpMetaIcon">🕒</span>
                  <div>
                    <p className="lpMetaTitleHero">Ao vivo</p>
                  </div>
                </div>

                <div className="lpMetaCard">
                  <span className="lpMetaIcon">💻</span>
                  <div>
                    <p className="lpMetaTitleHero">Online</p>
                  </div>
                </div>
              </div>
              <div className="lpHeroCtas lpHeroCtasCenter" id="cta-hero">
                <button
                  className="lpBtn lpBtnPrimary lpBtnBig"
                  onClick={() =>
                    (window.location.href = "https://chat.whatsapp.com/CZkAfFASn1aAl2bYoFYugH?mode=gi_t")
                  }
                >
                  {CTA_TEXT}
                </button>
              </div>
            </div>
          </div>
          <div className="lpHeroImage">
            <img
              fetchPriority="high"
              decoding="async"
              src={fotoSection}
              width="720"
              height="660"
              alt="Dra Célia Spingola e Dra Sandra Oliveira"
            />
          </div>
        </div>
      </section>

      {/* SEGUNDA DOBRA – IDENTIFICAÇÃO REAL */}
      <section className="lpSection lpSectionDarkVisual">
        <div className="lpHeroVideos">
          <div className="lpVideoGrid lpVideoGridWide">
            <div className="lpVideoCard">
              <p className="lpVideoTitle">Mensagem — Dra. Célia Spingola</p>
              <video
                className="lpVideo"
                controls
                preload="none"
                poster={capaCelia}
                width="275"
                height="342"
              >
                <source src={videoCelia} type="video/mp4" />
                Seu navegador não suporta vídeos HTML5.
              </video>
            </div>

            <div className="lpVideoCard">
              <p className="lpVideoTitle">Mensagem — Dra. Sandra Oliveira</p>
              <video
                className="lpVideo"
                controls
                preload="none"
                poster={capaSandra}
                width="275"
                height="342"
              >
                <source src={videoSandra} type="video/mp4" />
                Seu navegador não suporta vídeos HTML5.
              </video>
            </div>
          </div>
        </div>
        <div className="lpContainer">
          <h3 className="lpLeadSmall">
            Servidor público, veja se alguma dessas situações faz parte da sua
            realidade:
          </h3>

          <div className="lpBubblesWrap">
            <div className="lpBubblesGrid">
              {identificacaoPontos.map((t, i) => (
                <div className="lpBubble" key={i}>
                  {t}
                </div>
              ))}
            </div>
          </div>

          <div className="lpCalloutWide">
            <p className="lpCalloutText">
              Se qualquer um desses pontos descreve você, então você está no
              lugar certo. Esta imersão foi feita exatamente para quem quer
              resolver as dívidas, sem enrolação, sem promessas falsas e com um
              plano claro, estratégico e possível.
            </p>
          </div>
        </div>
      </section>

      {/* TERCEIRA DOBRA */}
      <section className="lpSection lpSectionLight">
        <div className="lpContainer">
          <h3 className="lpBigStatement">
            O banco não joga errado - Ele joga melhor.
          </h3>

          <div className="lpCompare">
            <div className="lpCompareCard">
              <h4 className="lpH4">Ele tem:</h4>
              <ul className="lpCompareList">
                {bancoTem.map((x, i) => (
                  <li className="lpCompareItem" key={i}>
                    {x}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lpCompareCard lpCompareCardAlt">
              <h4 className="lpH4">Você tem:</h4>
              <ul className="lpCompareList lpCompareListAlt">
                {voceTem.map((x, i) => (
                  <li className="lpCompareItem" key={i}>
                    {x}
                  </li>
                ))}
              </ul>
            </div>
          </div>

          <div className="lpTextBlock">
            <p className="lpLeadSmall">
              Mas a verdade é que existe, sim, uma forma de negociar diretamente
              com o banco de forma tranquila e organizada.
            </p>
            <p className="lpTextMuted">
              Aprenda a conduzir toda a negociação de maneira estratégica e
              consciente, sem enfrentar processos judiciais. Negocie com
              segurança e descubra, passo a passo, como uma negociação amigável
              deve ser feita.
            </p>
          </div>
        </div>
      </section>

      <section className="lpSection lpSectionAuthority">
        <div className="lpContainer lpStoryContainer">
          {/* FOTO */}
          <div className="lpStoryImage">
            <img
              src={fotoExperts}
              alt="Dra Célia Spingola e Dra Sandra Oliveira"
            />
          </div>

          {/* TEXTO */}
          <div className="lpStoryCard">
            <h3 className="lpStoryTitle">
              Nós sabemos disso porque já estivemos do outro lado da mesa.
            </h3>

            <p className="lpStoryText">
              Já vimos servidores saírem aliviados de uma renegociação e
              voltarem piores meses depois, não por falta de responsabilidade,
              mas porque aceitaram soluções que só prolongam o problema.
            </p>

            <p className="lpStoryText">
              Se você se vê em alguma dessas situações — com a sensação de que
              sua dívida nunca diminui, o constrangimento de dever e a confusão
              com contratos — então você está no lugar certo.
            </p>
          </div>
        </div>
      </section>

      {/* QUINTA DOBRA – O QUE ESSA IMERSÃO VAI FAZER POR VOCÊ */}
      <section className="lpSection lpSectionLight">
        <div className="lpContainer">
          <h2>O QUE ESSA IMERSÃO VAI FAZER POR VOCÊ</h2>
          <p className="lpStoryTitleOffer">
            Ao final da Imersão Servidor Sem Dívidas, você vai:
          </p>
          <div className="lpBenefitsGrid">
            <div className="lpCards">
              {beneficios.map((b, i) => (
                <div className="lpCard" key={i}>
                  <p className="lpCardTitle">{b}</p>
                </div>
              ))}
            </div>

            {/* OPCIONAL: imagem neutra (sem logo, sem “banco herói”) */}
            <aside className="lpBankVisual">
              <img
                src={fotoImersao}
                alt="Imagem ilustrativa neutra sobre organização financeira e contratos"
                loading="lazy"
              />
            </aside>
          </div>

          <div className="lpQuoteBar">
            <p className="lpQuoteStrong">Não é sobre pagar menos.</p>
            <p className="lpQuoteMuted">
              É sobre saber exatamente o que está fazendo.
            </p>
          </div>
        </div>
      </section>
      {/* SEXTA DOBRA – CONTEÚDO PROGRAMÁTICO */}
      <section className="lpSection lpSectionSoft">
        <div className="lpContainer">
          <h3 className="lph3">O que será abordado na imersão:</h3>

          {/* Cards (grid) */}
          <div className="lpProgramGrid">
            {conteudoProgramatico.map((t, i) => (
              <div className="lpProgramCard" key={i}>
                <div className="lpProgramTop">
                  <span className="lpProgramBadge">✔</span>
                  <span className="lpProgramTitle">{t}</span>
                </div>
              </div>
            ))}
          </div>

          <p className="lpProgramHint">
            Tudo explicado de forma{" "}
            <span className="lpHighlight">prática, direta e aplicável.</span>
          </p>
        </div>
      </section>

      {/* SÉTIMA DOBRA – PARA QUEM É / PARA QUEM NÃO É */}
      <section className="lpSection lpSectionSoft">
        <div className="lpContainer">
          <div className="lpTwoCols">
            <div className="lpPanel">
              <h3 className="lpH3">Essa imersão é para você que:</h3>
              <ul className="lpList">
                {paraQuemE.map((x, i) => (
                  <li key={i}>{x}</li>
                ))}
              </ul>
            </div>

            <div className="lpPanel lpPanelDark">
              <h3 className="lpH3">Não é para quem:</h3>
              <ul className="lpList">
                {paraQuemNaoE.map((x, i) => (
                  <li key={i}>{x}</li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* OITAVA DOBRA – EXPERTS */}
      <section className="lpSection lpSectionSoft">
        <div className="lpContainer">
          <h3 className="lph3">
            Quem somos nós para te conduzir nesse aprendizado
          </h3>

          <div className="lpExperts">
            <article className="lpExpertCard">
              <img
                className="lpExpertImg"
                src={fotoCelia}
                alt="Dra Célia Spingola"
              />
              <div className="lpExpertBody">
                <h3 className="lpExpertName">Dra Célia Spingola</h3>
                <p className="lpTextMuted">
                  Advogada, especialista em Direito bancário, ex- Gerente de
                  Banco,contadora, perita Grafotecnica, perita documentoscópica,
                  perita contábil, co-autora do livro mulheres do direito
                  bancário, expert em defesa do executado, graduada em processo
                  civil na Escola Superior de advocacia, vice-presidente da
                  comissão estadual de direito bancário ABA.
                </p>
              </div>
            </article>

            <article className="lpExpertCard">
              <img
                className="lpExpertImg"
                src={fotoSandra}
                alt="Dra Sandra Oliveira"
              />
              <div className="lpExpertBody">
                <h3 className="lpExpertName">Dra Sandra Oliveira</h3>
                <p className="lpTextMuted">
                  Sandra é advogada, professora e servidora pública, com atuação
                  sólida no Direito Bancário. Coautora de diversas obras
                  jurídicas na área, construiu sua trajetória unindo técnica,
                  prática e didática acessível. É especialista em
                  superendividamento, com foco na proteção e reorganização
                  financeira de servidores públicos. Atua de forma estratégica,
                  humanizada e comprometida com resultados reais.
                </p>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* NONA DOBRA – OFERTA */}
      <section id="oferta" className="lpSection lpOfferSection">
        <div className="lpContainer">
          <div className="lpOfferBody">
            <div className="lpOfferLeft">
              <h2 className="lpH2">OFERTA DA IMERSÃO</h2>
              <div className="lpHeadlineBlock">
                <h3 className="lpOfferMainTitle">Faça um 2026 diferente.</h3>
                <h3 className="lpOfferMainSub">
                  Não repita decisões financeiras por falta de conhecimento.
                </h3>
                <p className="lpOfferMainText">
                  Em uma imersão ao vivo e fechada, você vai finalmente entender
                  suas dívidas, saber o que pode ou não ser negociado e tomar
                  decisões com mais segurança antes de repetir erros que custam
                  caro ao longo do ano.
                </p>
              </div>

              <div className="lpMetaRow lpMetaRowCenter lpMetaCardsOffer">
                <div className="lpMetaCard">
                  <span className="lpMetaIcon">📅</span>
                  <div>
                    <p className="lpMetaTitle">{EVENT_DATE}</p>
                  </div>
                </div>

                <div className="lpMetaCard">
                  <span className="lpMetaIcon">🕒</span>
                  <div>
                    <p className="lpMetaTitle">{EVENT_DURATION}</p>
                  </div>
                </div>

                <div className="lpMetaCard">
                  <span className="lpMetaIcon">💻</span>
                  <div>
                    <p className="lpMetaTitle">Sala fechada</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="lpOfferRight">
              <p className="lpPriceLabel">Evento gratuito</p>{" "}
              <p className="lpPriceLabel">Entrar para o grupo via WhatsApp</p>{" "}
              <button
                className="lpBtn lpBtnPrimary lpBtnBig lpBtnFull"
                id="cta-secao-oferta"
                onClick={() =>
                  (window.location.href = "https://chat.whatsapp.com/CZkAfFASn1aAl2bYoFYugH?mode=gi_t")
                }
              >
                {" "}
                👉 Quero participar da imersão{" "}
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* DÉCIMA DOBRA – PONTE PARA O PRÓXIMO NÍVEL */}
      <section className="lpSection lpSectionLight">
        <div className="lpContainer">
          <h2 className="lpH2">PONTE PARA O PRÓXIMO NÍVEL</h2>

          <div className="lpBridgeCard">
            <p className="lpStoryTitleOffer">
              Importante ser honesto(a) com você: Entender muda o jogo. Mas
              fazer sozinho(a) ainda é onde a maioria erra.
            </p>
            <p className="lpStoryTitleOffer">
              Na imersão, você vai enxergar. Depois dela, você decide se quer
              acompanhamento para executar com segurança.
            </p>
            <p className="lpStoryTitleOffer">
              Nada será empurrado. Nada será escondido.
            </p>
          </div>
        </div>
      </section>

      {/* DÉCIMA PRIMEIRA DOBRA – CTA FINAL */}
      <section className="lpFinal">
        <div className="lpContainer">
          <div className="lpFinalCard">
            <h2 className="lpFinalTitle">
              Se isso descreve a sua realidade, não continue decidindo no
              escuro.
            </h2>
            <button
              className="lpBtn lpBtnPrimary lpBtnBig"
              id="cta-final"
              onClick={() =>
                (window.location.href = "https://chat.whatsapp.com/CZkAfFASn1aAl2bYoFYugH?mode=gi_t")
              }
            >
              👉 Evento gratuito
            </button>
          </div>

          <footer className="lpFooter">
            <p className="lpFooterText">
              © {new Date().getFullYear()} — Imersão Servidor Sem Dívidas. Todos
              os direitos reservados.
            </p>
            <a
              href="https://wa.me/5547989293394"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: "none" }}
            >
              <p className="lpFooterText">
                Desenvolvido por: João Arthur Lima da Silva •
              </p>
            </a>
          </footer>
        </div>
      </section>

      {/* Sticky CTA (mobile) */}
      <div className="lpSticky">
        <button
          className="lpStickyBtn"
          id="cta-botao-fixo"
          onClick={() =>
            (window.location.href = "https://chat.whatsapp.com/CZkAfFASn1aAl2bYoFYugH?mode=gi_t")
          }
        >
          Evento gratuito
        </button>
      </div>
    </div>
  );
}
